import { themeColors } from "../../config";

export const iconStyles = {
  container: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    color: themeColors.contentTextColor,
    padding: 10,
  },
  icon: {
    display: "flex",
    width: 50,
    height: 50,
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "50%",
    backgroundColor: themeColors.transparentBlack,
    boxShadow: "0 0 5px rgba(255,255,255,0.8)",
    margin: 5,
  },
  input: {
    fontSize: 15,
    width: 80,
    borderRadius: 5,
    flex: 1,
    fontFamily: "roboto",
    textShadow: "0 0 5px white",
    padding: 2,
    outline: "none",
    border: "none",
    backgroundColor: themeColors.transparentBlack,
    color: themeColors.optionTextColor,
  },
  name: {
    flex: 1,
    fontSize: 15,
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    fontFamily: "roboto",
    textShadow: "0 0 5px white",
    whiteSpace: "nowrap",
  },
};
